import { ForecastDeclineCurveTypeBase } from './base/forecast-decline-curve-type-base';

export class ForecastDeclineCurveType extends ForecastDeclineCurveTypeBase { }